import { render, staticRenderFns } from "./FeedbackTable.vue?vue&type=template&id=5ae1fed1&scoped=true"
import script from "./FeedbackTable.vue?vue&type=script&lang=js"
export * from "./FeedbackTable.vue?vue&type=script&lang=js"
import style0 from "./FeedbackTable.vue?vue&type=style&index=0&id=5ae1fed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae1fed1",
  null
  
)

export default component.exports